import PropTypes from 'prop-types';
import { memo } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { OverflowPopup } from 'components/General/Cells/OverflowPopup';
import { useTruncationAndOverflowPopup } from 'hooks/useCellTruncation';

import { Container, Wrap } from './styled';
import { onStopPropagation } from '../../../../utils/prevent-events';

LinkCell.propTypes = {
  to: PropTypes.string,
  value: PropTypes.string,
  onClick: PropTypes.func,
  navigationState: PropTypes.object,
};

function LinkCell({ value, to, width, onClick, navigationState }) {
  const { textRef, showPopup, handleMouseEnter, handleMouseLeave } =
    useTruncationAndOverflowPopup(value);
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (e) => {
    onStopPropagation(e);
    if (onClick) {
      onClick(e);
    } else if (to) {
      navigate(to, {
        state: navigationState || {
          referrer: location.pathname,
        },
      });
    }
  };

  return (
    <Wrap
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Container
        $width={width}
        ref={textRef}
      >
        {value}
      </Container>
      <OverflowPopup
        visible={showPopup}
        ref={textRef}
      >
        <Link to={to}>{value}</Link>
      </OverflowPopup>
    </Wrap>
  );
}

export const MemoizedLinkCell = memo(LinkCell);
